module.exports = __webpack_public_path__ + "img/product.d3b47123.png";